import { render } from "./ManageVendors.vue?vue&type=template&id=a306da3a&scoped=true"
import script from "./ManageVendors.vue?vue&type=script&lang=js"
export * from "./ManageVendors.vue?vue&type=script&lang=js"

import "./ManageVendors.vue?vue&type=style&index=0&id=a306da3a&scoped=true&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\BrikTokApi\\BrikTokAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a306da3a"]])

export default __exports__